import { Component } from "@angular/core";
import { XOField } from './xo-field.component';

@Component({
    selector: "xo-field-time",
    templateUrl: "./xo-field-time.component.html"
})
export class XOFieldTime extends XOField {
}
